module.exports = __webpack_public_path__ + "img/newsletter_bg.bf7875ea.png";